import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as UsersRolesActions from '../actions/users-roles.actions';
import { UsersService } from '../../../services/api/users/users.service';



@Injectable()
export class UsersRolesEffects {

  loadUsersRoles$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UsersRolesActions.loadUsersRoles),
      concatMap(() =>
        this.usersService.getUsersRoles().pipe(
          map(data => UsersRolesActions.loadUsersRolesSuccess({ data })),
          catchError(error => of(UsersRolesActions.loadUsersRolesFailure({ error }))))
      )
    );
  });



  constructor(private actions$: Actions,
              private usersService: UsersService) {}

}
